export const FRONTEND_SERVICES_API_URL =
  process.env.FE_TEST_RESULTS_API_URL ??
  'https://frontend-services.staging.signifyd.com'
